import React from 'react';
import {FastField, ErrorMessage} from 'formik';
import classNames from 'classnames';
import get from 'lodash/get';
import messages from '../../../../res/translations/messages';
import FormRow from './FormRow';
import Error from '../../Error';

const PageEditor = ({field, form}) => (
    <>
        <FormRow name={field.name} label={messages.surveys.form.label.pageId} size={3} tooltip={messages.surveys.form.tooltip.pageId}>
            <FastField id={field.name} name={field.name} type="text"
                className={classNames('form-control',
                    {error: get(form.errors, field.name) && get(form.touched, field.name)})} />
            <ErrorMessage name={field.name}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
        </FormRow>
    </>
);

export default PageEditor;
